<div class="wt-progress-wrapper" id="graph" data-percent="30" data-line="16" data-size="148"></div>